import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://yswlrxjzszuhhgpbsibo.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inlzd2xyeGp6c3p1aGhncGJzaWJvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk5NjExOTAsImV4cCI6MjA4NTUzNzE5MH0.w4FFxJuQq-7WSk80lsFB23cIS9WuTj5ueV92LDnPxfs'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})